module.exports = __webpack_public_path__ + "img/suppliers.f675469b.png";